module.exports = __webpack_public_path__ + "static/ATC-40b0e052e3460d5ac6cd4be961ca590f.jpg";